import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Highcharts from 'highcharts/es-modules/masters/highcharts.src';
import 'highcharts/es-modules/masters/modules/accessibility.src';
import 'highcharts/es-modules/masters/modules/broken-axis.src';
import 'highcharts/es-modules/masters/modules/exporting.src';
import 'highcharts/es-modules/masters/modules/offline-exporting.src';
import ImageUploadTemplate from '@/templates/data/image-upload.hbs';
import MapStatesView from '@/data/views/map_states';
import MapStationCountsView from '@/data/views/map_station_counts';
import '@/lib/highcharts_checkbox_position';

// if it returns undefined, then no line is shown
function startsBeforeZero (thisModel) {
  var value;
  thisModel.get('categories').forEach(function (cat, i) {
    if (i !== 0 && (cat === '0' || cat === '0%')) {
      value = i;
    }
  });

  return value;
}

export default Backbone.View.extend({
  initialize: function(options) {
    this.options = options;
    this.chart_width = this.options['chart_width'];
    $('div.chart-display').css('min-height', '400px');

    // Without wrapping render in a time out,
    // firefox sometimes fails to add some functionality - like tooltips and clickable legend.
    setTimeout(_.bind(this.render, this), 0);
  },

  setChartWidth: function(width) {
    if(width != this.chart_width) {
      this.chart_width = width;
      if(this.chart) {
        var height = this.chart.height;
        this.chart.setSize(width, height, false);
      }
    }
  },

  render: function() {
    // For IE8-9, there are some odd double or triple render calls on page
    // load for deep links (eg, when "/data/10501" loads, then redirects to
    // "/data/#10501"). This leads to the app actually rendering the
    // "default" chart once (really, just the first chart on the page),
    // before then loading the actually requested chart. This sometimes leads
    // to multiple charts showing up inside the modal in IE8-9 (or whitespace
    // consumed by where the highchart would have been). Ideally, we'd
    // cleanup the load process, but as a simple workaround, let's just
    // always make sure we wipe the rendered content before each new render
    // to ensure we at least never have multiple charts showing up.
    $('div.chart-display').empty();

    if (this.model.get("renderer") == 'highcharts') {
      this.chart = new Highcharts.Chart(this.highchart_config());
    } else if (this.model.get("renderer") == 'google-geocharts') {
      if(this.model.get('display_type') == 'map-station') {
        new MapStationCountsView({
          el: this.el,
          model: this.model
        });
      } else {
        new MapStatesView({
          el: this.el,
          model: this.model
        });
      }
    } else if (this.model.get("renderer") == "image") {
      this.$el.html(ImageUploadTemplate(this.model.toJSON()));
    } else {
      $('div.chart-display').css('min-height', '0px');
      this.$el.html('<div class="map-title">'+this.model.get("title")+'</div>');
    }
  },

  destroy: function() {
    // make sure that if the user clicks on the same model, all the series
    // show up again
    if (this.model.get('series')) {
      this.model.get('series').forEach(function (s) {
        s.visible = true;
      });
    }

    // clean up from old model, as appropriate for renderer
    switch(this.model.get("renderer")){
      case "highcharts":
        if (this.chart != undefined) {
          this.chart.destroy();
        }
        break;
      case "google-geocharts":
        if (this.chart != undefined) {
          this.chart.clearChart();
        }
        break;
       }

    // some extra cleanup.
    // this.chart = undefined;
  },

  // return complete config object for highcharts
  highchart_config: function() {
    // apply sequence of decorators to customize config object for the model properties
    return this.common(this.chart_det(this.legend(this.plotops(this.tooltip(this.xaxis(this.yaxis({})))))));
  },


  //
  //  ---- decorator functions used within config() to assemble the highchart config object -----
  //
  // config common to all chart types
  common: function(config) {
    config["title"] = {
      text: this.model.get("title"),
      style: {
        width: 600
      }
    };
    config["credits"] = this.model.get("credits");
    if (this.model.get("chart_type") == "dual") {
      var tmp = this.model.get("series");
      // specific colors for dual charts - this allows axes to match
      tmp[0].color = "#4572A7";
      tmp[1].color = "#AA4643";
      if (tmp.length === 3) {
        tmp[2].color = "#88b437";
      }
      config["series"] = this.model.get("series");
    }
    else {
      config["series"] = this.model.get("series");
    }

    config["navigation"] = {
        buttonOptions: {
          theme: {
            // Good old text links
            style: {
              color: '#039',
              textDecoration: 'underline'
            }
          }
        },
        menuItemStyle: {
          padding: '0 .5em',
        }
    }

    config["exporting"] = {
      menuItemDefinitions: {
        downloadExcel: {
          text: "Download Excel spreadsheet",
          onclick: _.bind(this.downloadSpreadsheet, this),
        },
      },
//        buttons: {
//          contextButton: {
//            text: "Download/Print"
//          }
//        }
      buttons: {
        contextButton: {
          enabled: false
        },
        exportButton: {
          enabled: true,
          text: 'Download',
          menuItems:[
            "downloadExcel",
            "separator",
            "downloadPNG",
            "downloadPDF",
            "downloadSVG",
          ],
        },
        printButton: {
          text: 'Print',
          onclick: function () {
            this.print();
          }
        }
      }
    };

    if (this.model.attributes.id === 10313) {
      // use custom colors for the fuel economy and consumption chart
      config["colors"] = ['#2f7ed8', '#fabd17', '#8bbc21', '#910000', '#f28f43'];
    } else if (this.model.attributes.id === 10326) {
      // use custom colors for the fuel prices chart
      config["colors"] = ["#2f7ed8", "#fabd17", "#7Ab800", "#910000", "#00b2ff", "#492970", "#f28f43", "#007934", "#e7888A"];
    } else if (this.model.attributes.id === 10332) {
      // use custom colors for the station counts chart
      config["colors"] = ["#b53352", "#265bb2", "#2db262", "#ccc876", "#a2d5e0", "#134427", "#999999", "#9b8bcc", "#f09e91"];
    } else {
      config["colors"] = this.model.get("colors");
    }

    var theModel = this.model;
    config["chart"]["events"] = {
      load: function () {
        if (theModel.get("on_chart_load")) {
          theModel.get("on_chart_load");
        }

        var label = this.renderer.label("Last updated: " + theModel.get('last_update') + "<br>Printed on: " + window.PrintDate, null, null, null, null, null, true, null, 'print-labels')
          .css({
            width: '450px',
            color: '#222',
            fontSize: '8px',
            fontStyle: 'italic'
          })
          .add();

        label.align(Highcharts.extend(label.getBBox(), {
          align: 'left',
          x: 0, // offset
          verticalAlign: 'bottom',
          y: 25 // offset
        }), null, 'spacingBox');
      }
    };
    config["chart"]["spacingBottom"] = 30; // for printing

    return config;
  },
  chart_det: function(config) {
    switch(this.model.get("chart_type")){
      case "pie":
        config["chart"] = { renderTo: this.el.id,
          plotBackgroundColor: null, plotBorderWidth: null,
          plotShadow: false, width: this.chart_width };
        break;
      default:
        config["chart"] = { renderTo: this.el.id,
          type: this.model.get("chart_type"),
          width: this.chart_width, backgroundColor: null };
    }
    return config;
  },
  legend: function(config) {
    switch(this.model.get("chart_type")){
      case "dual":
      // put legend below dual charts - otherwise too smooshd with the 2 axes
        config["legend"] = {
          margin: 20,
          borderWidth: 0,
          itemMarginTop: 2,
          itemMarginBottom: 5,
          itemDistance: 4
        };
        break;
      default:
        if (this.model.get("series").length > 1) {
          config["legend"] = {
            itemStyle: {
              width: '100px',
              padding: '2px',
              lineHeight: '13px',
              textOverflow: undefined
            },
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: -10,
            y: 60,
            borderWidth: 0,
            maxHeight: 600,
            margin: 20,
            symbolRadius: 0,
          };
        }
        else {
          config["legend"] = { enabled: false }
        }
        break;
    }
    return config;
  },
  plotops: function(config) {
    var model = this.model;
    config["plotOptions"] = model.get("plotOptions");
    switch(model.get("display_type")){
      case "chart-pie":
        config["plotOptions"] = {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              color: '#000000',
              connectorColor: '#000000',
              formatter: function() {
                if (model.get("round_percents") == true) {
                  return '<b>'+ this.point.name +'</b>: '+ (Math.round(this.percentage*100) / 100).toFixed(0) +' %';
                }
                else {
                  return '<b>'+ this.point.name +'</b>: '+ Math.round(this.percentage*100) / 100 +' %';
                }
              }
        }}};
        break;
    }
    if (model.get("display_type") != "chart-pie") {
      if (typeof(config["plotOptions"]) === 'undefined') {
        config["plotOptions"] = {};
      }
      config["plotOptions"]["series"] = {
        showCheckbox: true,
        selected: true,
        events: {
          checkboxClick: function() {
            if (this.visible) {
              this.hide();
              $(this.checkbox).prop("checked", false);
            }
            else {
              this.show();
              $(this.checkbox).prop("checked", true);
            }
            return false;
          },
          hide: function() {
            $(this.checkbox).prop("checked", false);
          },
          show: function() {
            $(this.checkbox).prop("checked", true);
          }
        }
      }
    }
    return config;
  },
  tooltip: function(config){
    var context = this;
    switch(this.model.get("display_type")){
      case "chart-pie":
        config["tooltip"] = {useHTML: true, shadow: false, borderWidth: 0, backgroundColor: 'rgba(0,0,0,0)', style: {zIndex: 999}, formatter: function() {
          return '<b>'+ this.point.name +'</b>: '+ (Math.round(this.percentage * 100) / 100) +' %';
        }};
        break;
      case "chart-stackedcolumn":
        config["tooltip"] = {useHTML: true, shadow: false, borderWidth: 0, backgroundColor: 'rgba(0,0,0,0)', style: {zIndex: 999}, formatter: function() {
          const yval = (this.point.name == 'n/a') ? 'n/a' : context.axis_label_formatter(this.y);
          return '<b>'+ this.x +'</b><br/>'+ this.series.name +': '+ yval +'<br/>'+'Total: '+ context.axis_label_formatter(this.point.stackTotal);
        }};
        break;
      default:
        config["tooltip"] = {useHTML: true, shadow: false, borderWidth: 0, backgroundColor: 'rgba(0,0,0,0)', style: {zIndex: 999}, formatter: function() {
        return '<b>'+ this.x +'</b><br/>'+ this.series.name +': '+ context.axis_label_formatter(this.y)
      }};
      break;
    }
    return config;
  },
  xaxis: function(config) {
    const cats = this.model.get("categories");
    // skep every other label only if there are more than 15 total,
    // AND we guess that they are years
    var step_size = 1;
    if (cats.length > 15 && String(cats[cats.length-1]).indexOf("20")!= -1  ) {
      // step_size = (cats.length > 25) ? 4 : 2;
      step_size = Math.round(cats.length / 10) + 1;
    }

    // if there's too many ticks, show less to avoid
    // the strange "stair-stepping" thing with the labels
    var tickInterval;
    if (cats.length > 20) {
      tickInterval = Math.round(cats.length / 10) + 1;
      step_size = 1;
    }

    // show all x-axis labels for the chart of fuel taxes by country
    // and the chart of EV registration counts by state
    if (this.model.attributes.id === 10327 || this.model.attributes.id === 10962) {
      tickInterval = 1;
    }

    // create custom buckets for the fuel economy and consumption chart
    if (this.model.attributes.id === 10313) {
      tickInterval = 10;
    }

    switch(this.model.get("chart_type")) {
      case "bar":
        config["xAxis"] = {
          title: { y: 30, text: this.model.get("xaxis") },
          categories: this.model.get("categories"),
          labels: { step: step_size },
          tickInterval: tickInterval
        };
        break;
      default:
        var stagger_lines = null;
        var rotation = 0;
        var y = 20;
        if (cats.length > 5 && cats[0].length > 3) {
          if (cats.length > 15) {
            rotation = 90;
            y = 40;
          }
          else {
            stagger_lines = 2;
          }
        }

        config["xAxis"] = {
          title: { text: this.model.get("xaxis"), margin: 25 },
          categories: this.model.get('chart_type') === 'spline' || this.model.get('chart_type') === 'scatter' ? null : this.model.get("categories"),
          labels: { rotation: rotation, step: step_size, y: y, staggerLines: stagger_lines },
          plotLines: [{
            color: 'lightBlue',
            width: 1,
            value: startsBeforeZero(this.model),
            dashStyle: 'dash'
          }],
          tickInterval: tickInterval,
          tickWidth: 1
        };
    }
    return config;
  },



  yaxis: function(config) {
    switch (this.model.get("chart_type")) {
      case "dual":
         var yaxis = this.model.get("yaxis").split("|");
         config["yAxis"] = [{min: 0, title: { text: yaxis[0],       style: {
          color: '#4572A7',
          fontFamily: 'Arial',
          fontWeight: 'bold',
          fontSize: '1em'
        } }}, {min: 0, title: { text: yaxis[1], style: {
          color: '#AA4643',
          fontFamily: 'Arial',
          fontWeight: 'bold',
          fontSize: '1em'
        } }, opposite: true, margin: 25 }];
         break;
      default:
        var context = this;

        // get the lowest value across all series in the chart
        var dataMin = function () {
          var allSeries = context.model.get('series');

          var min = 0;
          allSeries.forEach(function (series) {
            series.data.forEach(function (point) {
              if (point < min) {
                min = point;
              }
            });
          });
          return min;
        };
        dataMin();

        var yAxisMin = dataMin();

        if (this.model.attributes.id === 10316) {
          yAxisMin = 210;
        } else if (this.model.attributes.id === 10881) {
          yAxisMin = -100;
        }

        config["yAxis"] = {
          title: { margin: 25, text: this.model.get("yaxis") },
          labels: {formatter: function() {return context.axis_label_formatter(this.value) }},
          min: yAxisMin,
          gridLineColor: '#c0c0c0',
        };

        if (this.model.attributes.id === 10881) {
          config.yAxis.max = 100;
        }

        // break the y-axis for the chart of EV registration counts by state
        if (this.model.attributes.id === 10962) {
          config.yAxis.breaks = [{
            from: 200000,
            to: 800001,
          }];
          config.yAxis.tickInterval = 200000;
          config.yAxis.max = 900000;
        }
    }
    return config;
  },

  downloadSpreadsheet: function() {
    window.location = this.model.get("spreadsheet");
  },

  embed: function() {
    window.location = "/data/widgets/" + this.model.get("id");
  },

  axis_label_formatter: function(value) {
    // alert(typeof(value));
    // switch(scale){
    //   case "thousands":
      // display full number with commas
      const digits = (value % 1 > 0 && value < 100) ? 2 : 0;

      return Highcharts.numberFormat(value, digits, '.', ',');
      //   break;
      // case "millions":
      // // display abbreviated with 'm'
      //   return Math.round(value / 1000000) + "m";
      //   break;
      // default:
      // round to 2 digits after decimal
        // return Highcharts.numberFormat(value, 2, '.');

  },
});
